import React from "react";
import { useHistory } from "react-router-dom";

const AnalItem = () => {
  const history = useHistory();
  let atAnal = history.location.pathname === "/dashboard/anal";
  return (
    <div
      onClick={() => {
        history.push("/dashboard/anal");
      }}
      className={`mt-4 cursor-pointer flex flex-row items-center h-12 px-4 rounded-lg text-gray-600  hover:bg-gray-100 ${
        atAnal ? "bg-gray-100" : "bg-white"
      }`}
    >
      <span className="flex items-center justify-center text-lg text-orange-400">
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
          />
        </svg>
      </span>
      <span className="w-full pl-3 flex justify-between items-center">
        <span>Analytics</span>
        <div className="py-1 px-2 bg-red-400 rounded-lg text-white text-xs">
          preview
        </div>
      </span>
    </div>
  );
};

export default AnalItem;
